import { DynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import ExchangeMetricsForm from "./PriceAnalysisForm";
// import ExchangeMetricsPage from "./PriceAnalysisForm";

export function DemoExchangeMetricsPage() {
  return (
    <DynamicTab
      header=""
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      showTabs={false}
      tabs={{
        Form: <ExchangeMetricsForm />,
      }}
    />
  );
}
